import{gql as e}from"graphql-tag";import{ConversationFragmentDoc as o,CoachFragmentDoc as n,MemberFragmentDoc as r,MessageFragmentDoc as t,MessageResourceFragmentDoc as a,MessageMeditationResourceFragmentDoc as s,MessageProgramResourceFragmentDoc as c}from"./fragments.generated.es.js";const i=e`
    subscription onNewConversation {
  onNewConversation {
    ...conversation
  }
}
    ${o}
${n}
${r}
${t}
${a}
${s}
${c}`;export{i as OnNewConversationDocument};
//# sourceMappingURL=onNewConversationSubscription.generated.es.js.map
